import APIClient from '@/shared/http/clients/api'

const resourceName = 'AprTemplateCursosNr'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAPRTemplateCursosNRGrid = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAPRTemplateCursosNRGrid?limit=${limit}&index=${index}`, data, config)

const AprCoursesRepository = {
  GetAPRTemplateCursosNRGrid
}

export default AprCoursesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprCoursesNR.js